import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';

export type HomeIdentity = {
  displayName: string;
  firstName: string;
  email?: string;
  userEntityRef: string;
  ownershipEntityRefs: string[];
};

export const useHomeIdentity = () => {
  const identityApi = useApi(identityApiRef);

  return useAsync(async (): Promise<HomeIdentity> => {
    const [profile, identity] = await Promise.all([
      identityApi.getProfileInfo(),
      identityApi.getBackstageIdentity(),
    ]);
    const displayName = profile.displayName ?? 'there';
    return {
      displayName,
      firstName: displayName.split(' ')[0],
      email: profile.email,
      userEntityRef: identity.userEntityRef,
      ownershipEntityRefs: identity.ownershipEntityRefs,
    };
  }, [identityApi]);
};
